import { Chip, Link, Stack, Typography } from "@mui/material";
import { Link as RouterLink } from "react-router-dom";

import { formatNumber } from "../../../../../../infrastructure/utils/formatters";
import { ManagementWidgetShell } from "../managementDashboardWidgets";
import { buildDrillDownHref, pick } from "../managementDashboardUtils";

const RISK_LABELS = {
  1: "پایین",
  2: "متوسط",
  3: "بالا",
  4: "بحرانی",
  Low: "پایین",
  Medium: "متوسط",
  High: "بالا",
  Critical: "بحرانی",
};

const RISK_COLORS = {
  1: "success",
  2: "warning",
  3: "error",
  4: "error",
  Low: "success",
  Medium: "warning",
  High: "error",
  Critical: "error",
};

const RequestRiskPreviewPanel = ({ loading, error, data, onRetry }) => {
  const items = data?.items || data?.Items || [];

  return (
    <ManagementWidgetShell
      title="پیش‌بینی ریسک (قاعده‌محور)"
      subheader="بدون ML — بر اساس SLA و داده عملیاتی"
      loading={loading}
      error={error}
      onRetry={onRetry}
    >
      <Stack spacing={1}>
        {items.map((row) => {
          const id = pick(row, "requestId", "RequestId");
          const level = pick(row, "riskLevel", "RiskLevel");
          const href = buildDrillDownHref(pick(row, "drillDown", "DrillDown"));
          const reasons = row.riskReasons || row.RiskReasons || [];

          return (
            <Stack
              key={id}
              spacing={0.5}
              sx={{ borderBottom: "1px solid", borderColor: "divider", pb: 1 }}
            >
              <Stack direction="row" spacing={1} alignItems="center" flexWrap="wrap">
                <Chip size="small" color={RISK_COLORS[level] || "default"} label={RISK_LABELS[level] || level} />
                {href ? (
                  <Link component={RouterLink} to={href} underline="hover" fontWeight={600}>
                    #{pick(row, "referenceId", "ReferenceId")}
                  </Link>
                ) : (
                  <Typography fontWeight={600}>#{pick(row, "referenceId", "ReferenceId")}</Typography>
                )}
                <Typography variant="body2" color="text.secondary">
                  {pick(row, "applicantName", "ApplicantName")}
                </Typography>
                <Chip
                  size="small"
                  variant="outlined"
                  label={`احتمال نقض: ${formatNumber(pick(row, "expectedSlaBreachProbability", "ExpectedSlaBreachProbability"), 1)}٪`}
                />
              </Stack>
              <Typography variant="caption" color="text.secondary">
                {(reasons || []).join(" · ")}
              </Typography>
            </Stack>
          );
        })}
        {!items.length && !loading && !error ? (
          <Typography color="text.secondary">درخواست با ریسک متوسط/بالا در فیلتر فعلی یافت نشد.</Typography>
        ) : null}
      </Stack>
    </ManagementWidgetShell>
  );
};

export default RequestRiskPreviewPanel;
